module.exports = __webpack_public_path__ + "static/img/weather-bg-16.c231eba.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/weather/weather-bg-16.gif
// module id = vwpW
// module chunks = 1